import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setAccountAsFremiumError: {
    id: 'freemium.setAccountAsFremiumError',
    defaultMessage: 'Operacja się nie powiodła. Spróbuj ponownie za kilka minut.',
  },
});
